module.exports = __webpack_public_path__ + "static/media/GestaoRonda-logo-semFundo.39b56fb4.png";